import React from "react";
import { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import { FlightPackageContentFragment } from "types/graphql-types";
import { PrePostItem } from "../../types";
import CruiseItineraryFlightPackage from "../CruiseItineraryFlightPackage/CruiseItineraryFlightPackage";
import CruiseItineraryPrePostItem from "../CruiseItineraryPrePostItem/CruiseItineraryPrePostItem";
import { isPresent } from "src/utils/checks";

type UnbundlingCruiseItineraryPrePostItemProps = {
  items: readonly PrePostItem[];
  flightPackage?: FlightPackageContentFragment;
  tokenValues?: TokenValues;
  prePostSection: "PRE" | "POST";
};

const codesToExclude = [
  "PreDoor2Door",
  "PostDoor2Door",
  "TransferInternationalAirportToPier",
  "TransferPierToInternationalAirport",
  "TransferInternationalAirportToHotel",
  "TransferHotelToInternationalAirport",
  "EconomyFlights",
  "EconomyFlightsWithUpgrade",
  "BusinessFlights",
  "BusinessUpgraded"
]; // TODO - unbundling: remove codesToExclude when new fares are available

export const UnbundlingCruiseItineraryPrePostItem: React.FC<
  UnbundlingCruiseItineraryPrePostItemProps
> = ({ items, flightPackage, tokenValues, prePostSection }) => {
  const showableInclusions = items.filter(
    (item) => !codesToExclude.includes(item.inclusionCode)
  );
  return (
    <React.Fragment>
      {prePostSection === "PRE" && isPresent(flightPackage) && (
        <CruiseItineraryFlightPackage flightPackage={flightPackage} />
      )}

      {showableInclusions.map((item) => (
        <CruiseItineraryPrePostItem
          item={item}
          key={`${prePostSection}-${item.inclusionCode}-${item.date}`}
          tokenValues={tokenValues}
        />
      ))}

      {prePostSection === "POST" && isPresent(flightPackage) && (
        <CruiseItineraryFlightPackage flightPackage={flightPackage} />
      )}
    </React.Fragment>
  );
};
